import type { InputAction } from './InputAction';
import type { InputSource } from './InputSource';

/**
 * Collects actions from all sources into a per-frame queue. The game drains
 * the queue once per frame: meta actions (pause, debug) are handled
 * directly, gameplay actions go to the player's input buffer.
 */
export class InputManager {
  private readonly queue: InputAction[] = [];
  private readonly sources: InputSource[] = [];
  private enabled = true;

  add(source: InputSource): void {
    this.sources.push(source);
    source.attach((action) => {
      if (this.enabled) this.queue.push(action);
    });
  }

  drain(): InputAction[] {
    return this.queue.splice(0, this.queue.length);
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    if (!enabled) this.queue.length = 0;
  }

  dispose(): void {
    for (const source of this.sources) source.detach();
    this.sources.length = 0;
  }
}
